import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useDispatch } from "react-redux";
import { MdOutlineMail } from "react-icons/md";
import "../../Assets/Scss/NewsLetter.scss";
import { postNewsletteraction, resetNewsletterStateAction } from "../../Store/NewsLetter/action";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../Ui/Loader";

export default function NewsLetter() {
  const { successMessage, loading, sucess, errorMessage } = useSelector(
    (state) => state.Newsletter
  );

  const { domainData } = useSelector((state) => state.Website);

  const dispatch = useDispatch();

  const [email_id, setEmail] = useState("");

  const validate = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

  const handleNewsletter = () => {
    if(!(validate(email_id))){
    toast.error("Please provide a valid email address.")
    return;
  }
    dispatch(postNewsletteraction({ email_id }));
  };

  React.useEffect(()=>{
  // console.log("45879====97876")
   if(sucess){
      toast.success(successMessage);
    dispatch(resetNewsletterStateAction());
    }

    if(errorMessage){
      toast.error(errorMessage);
    dispatch(resetNewsletterStateAction());
    }

  },[dispatch, errorMessage, loading, successMessage, sucess])

  return (
    <>
    <div
      style={{
        padding: "2% 0",
        marginBottom: "2%",
        backgroundColor: "grey",
        textAlign: "center",
      }}
    >
    
    {loading && <Loader />}
      <MdOutlineMail style={{ color: "red", fontSize: "140%" }} />
      <p style={{ color: "white", display: "inline", paddingLeft: "5px" }}>
        Sign up for the weekly email newsletter with the best money-saving
        coupons.
      </p>
      {!sucess ? (
        <InputGroup id="news-letter" className="mb-2 mt-3">
          <Form.Control
            className="shadow-none"
            placeholder="Your email.."
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
            name="email_id"
            value={email_id}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Button
            className="shadow-none"
            style={{
              backgroundColor: "#7ed321",
              color: "white",
              borderColor: "#7ed321",
            }}
            variant="outline-secondary"
            id="button-addon2"
            onClick={() => handleNewsletter()}
          >
            Subscribe
          </Button>
        </InputGroup>
      ) : sucess ? (
        <b
          style={{
            color: domainData ? domainData.header_color : "#fff",
          }}
        >
          <br />
          {successMessage}
        </b>
      ) : (
        <b>
          <br />
          {errorMessage}
        </b>
      )}

      <p style={{ color: "red" }}>{errorMessage ? errorMessage : ""}</p>
      <p style={{ color: "white" }}>
        We will never share your email with a third-party.
      </p>
      <ToastContainer
        position='top-right'
      />
    </div>
    </>
  );
}
